import { DEFAULT_LICENSES_MODAL_STATE } from './defaultLicensesModalState';

export type LicensesModalAction =
  | { type: 'setIsViewMode'; isViewMode: boolean }
  | { type: 'setToSuspendAutorenewal'; toSuspendAutorenewal: string[] }
  | { type: 'setToEnableAutorenewal'; toEnableAutorenewal: string[] }
  | { type: 'setLicensesSubscriptionCost'; licensesSubscriptionCost: number }
  | { type: 'setLicensesSubscriptionFullPeriodCost'; licensesSubscriptionFullPeriodCost: number }
  | {
      type: 'setLicensesSubscriptionInfo';
      licensesSubscriptionCost: number;
      licensesSubscriptionFullPeriodCost: number;
    }
  | { type: 'resetState' };

export type LicensesModalState = {
  toSuspendAutorenewal: string[];
  toEnableAutorenewal: string[];
  licensesSubscriptionCost: number;
  licensesSubscriptionFullPeriodCost: number;
  isViewMode: boolean;
};

export const licensesModalReducer = (state: LicensesModalState, action: LicensesModalAction): LicensesModalState => {
  switch (action.type) {
    case 'setIsViewMode': {
      return {
        ...state,
        isViewMode: action.isViewMode,
      };
    }
    case 'setToSuspendAutorenewal': {
      return {
        ...state,
        toSuspendAutorenewal: [...action.toSuspendAutorenewal],
      };
    }
    case 'setToEnableAutorenewal': {
      return {
        ...state,
        toEnableAutorenewal: [...action.toEnableAutorenewal],
      };
    }
    case 'setLicensesSubscriptionCost': {
      return {
        ...state,
        licensesSubscriptionCost: action.licensesSubscriptionCost,
      };
    }
    case 'setLicensesSubscriptionFullPeriodCost': {
      return {
        ...state,
        licensesSubscriptionFullPeriodCost: action.licensesSubscriptionFullPeriodCost,
      };
    }
    case 'setLicensesSubscriptionInfo': {
      return {
        ...state,
        licensesSubscriptionCost: action.licensesSubscriptionCost,
        licensesSubscriptionFullPeriodCost: action.licensesSubscriptionFullPeriodCost,
      };
    }
    case 'resetState': {
      return {
        ...state,
        ...DEFAULT_LICENSES_MODAL_STATE,
      };
    }
    default:
      return state;
  }
};
